/**
 * New look: amounts of 1,000 and more are shown rounded with thousands
 * separators; smaller ones keep the statistic's own precision.
 */
export const formatStatisticAmount = (
  value: number,
  getDisplayedValue: (value: number) => number | string
) =>
  Math.abs(value) > 999
    ? Math.round(value).toLocaleString("en-US")
    : getDisplayedValue(value);
